<template>
  <div>
    <transition name="ani-slide-in">
      <component v-if="!$auth.loading && !$workSessions.loading" :is="activeComponent"></component>
    </transition>
  </div>
</template>
<script>

import ClientProjectSettings from "../components/modules/settings/ClientProjectSettings";
import ReportProcessIssueComponent from "../components/modules/processIssue/ProcessIssueComponent"
import CapSaveStateInvalidatorMixin from "../mixins/capSettings/CapSaveStateInvalidatorMixin";
import authMixin from "@/auth/sanctum/mixins/authMixin";
import WSReliantComponentMixin from "@/workSessions/mixins/WSReliantComponentMixin";

export default {
  name: "ReportProcessIssue",
  data: () => {
    return {
      currentComponent: 'cPSettings'
    }
  },
  components: {
    cPSettings: ClientProjectSettings,
    rPIComponent: ReportProcessIssueComponent
  },
  computed: {
    activeComponent() {
      if (this.hasValidWorkSession || this.$store.state.capsSaveValidated) {
        return 'rPIComponent'
      }
      return 'cPSettings'
    }
  },
  mixins: [CapSaveStateInvalidatorMixin, authMixin, WSReliantComponentMixin],
  created() {
    //DISPATCH LOCATION GRAB
    this.$store.dispatch('getUserLocation');
  }
}
</script>